import { useEffect, useState } from 'react';
import { useInView } from 'react-intersection-observer';
import { useCountUp } from '../../../hooks/useCountUp';

/*
 * AnimatedCounter — número que cuenta hacia arriba al entrar al viewport.
 * Envuelve el hook useCountUp + useInView. Reutilizable en cualquier stat.
 * `delay` (ms, opcional) retrasa el inicio del conteo para sincronizarlo con la
 * animación de entrada de la card que lo contiene (default 0 = comportamiento previo).
 */
export default function AnimatedCounter({ end, duration = 1600, prefix = '', suffix = '', className = '', delay = 0 }) {
  const { ref, inView } = useInView({ triggerOnce: true, rootMargin: '-30px' });
  const [started, setStarted] = useState(delay === 0);

  useEffect(() => {
    if (!inView || delay === 0) return undefined;
    const t = setTimeout(() => setStarted(true), delay);
    return () => clearTimeout(t);
  }, [inView, delay]);

  const n = useCountUp(end, duration, inView && started);
  return (
    <span ref={ref} className={`tabular-nums ${className}`}>
      {prefix}{n}{suffix}
    </span>
  );
}
